var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "attach",
    d: "M20,5.306a5.925,5.925,0,0,1-.476,2.331A6.152,6.152,0,0,1,18.2,9.608L10.153,17.6,9.039,16.5,17.089,8.51a4.3,4.3,0,0,0,1.33-3.2,3.6,3.6,0,0,0-3.7-3.709,4.525,4.525,0,0,0-3.234,1.35l-8.859,8.8a3.309,3.309,0,0,0-1.06,2.394,2.263,2.263,0,0,0,.665,1.683,2.306,2.306,0,0,0,1.689.657,3.316,3.316,0,0,0,2.408-1.062l6.774-6.7a2.752,2.752,0,0,0,.952-1.746.7.7,0,0,0-.288-.594,1.106,1.106,0,0,0-.683-.216,2.083,2.083,0,0,0-1.546.72L5.427,12.938l-1.1-1.1,6.092-6.048A3.675,3.675,0,0,1,13.082,4.6a2.626,2.626,0,0,1,1.8.666,2.156,2.156,0,0,1,.754,1.692,4.2,4.2,0,0,1-1.419,2.862l-6.774,6.7a4.823,4.823,0,0,1-3.522,1.512,3.823,3.823,0,0,1-2.794-1.107A3.74,3.74,0,0,1,0,14.144a4.8,4.8,0,0,1,1.509-3.492l8.859-8.8A6.045,6.045,0,0,1,14.717.032,5.177,5.177,0,0,1,20,5.306Z",
    transform: "translate(0 -0.032)",
    fill: "#0267c1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.354cbc3b63f1567c4566bc6aea29c3a2.svg";
export { ForwardRef as ReactComponent };